import { Get, GetComToken } from './BaseService';
import { API_URL, authHeaders } from '../../config/api';

const urlAreaNaoLogada = `${API_URL}/Arvore`;
const urlAreaLogada = `${API_URL}/Arvore`;

export async function CompleteTree (languageId, email) {
    email = email.replace('@', '%40');
    const endpoint = '/ArvoreCompleta?idiomaId=' + languageId + "&emailUsuario=" + email;
    const headers = authHeaders();

   return await GetComToken(urlAreaLogada + endpoint, headers);
}

export async function GetIndexTree (languageId) {
    const endpoint = '/ArvoreIndex?idiomaId=' + languageId;

    const headers = { 
        'Accept': 'application/json',
    };

    return await Get(urlAreaNaoLogada + endpoint, headers);
}